import classNames from 'classnames';
import React from 'react';

import styles from './indicatorRadio.scss';

interface IndicatorRadioProps {
  containerStyles?: string;
  isSelected?: boolean;
}

export default function IndicatorRadio(props: IndicatorRadioProps) {
  const { containerStyles, isSelected } = props;
  const mainContainerStyles = classNames(
    styles.indicatorRadioContainer,
    containerStyles,
    'indicatorRadio',
    {
      [styles.indicatorRadioContainer_isSelected]: isSelected
    }
  );
  return <span className={mainContainerStyles} />;
}
